module.exports = __webpack_public_path__ + "media/packs/images/flags/PF-e46e1b6a5f7124c4c3b6037ea54af9de.svg";